// Australian formatting helpers
export const AUD = new Intl.NumberFormat("en-AU", {
  style: "currency",
  currency: "AUD",
  maximumFractionDigits: 0,
});

export const AUDcents = new Intl.NumberFormat("en-AU", {
  style: "currency",
  currency: "AUD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function fmtMoney(n, cents = false) {
  const v = Number(n || 0);
  return (cents ? AUDcents : AUD).format(v);
}

// DD/MM/YYYY
export function fmtDate(iso) {
  if (!iso) return "-";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "-";
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  return `${dd}/${mm}/${d.getFullYear()}`;
}

// yyyy-mm-dd for <input type=date>
export function toDateInput(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toISOString().slice(0, 10);
}

export function todayInput() {
  return new Date().toISOString().slice(0, 10);
}

export const STATUS_META = {
  not_quoted:  { label: "Not Quoted",  cls: "bg-status-neutral-bg text-status-neutral-text border-status-neutral-border" },
  quoted:      { label: "Quoted",      cls: "bg-blue-50 text-blue-700 border-blue-200" },
  not_started: { label: "Not Started", cls: "bg-status-neutral-bg text-status-neutral-text border-status-neutral-border" },
  part_paid:   { label: "Part Paid",   cls: "bg-status-part-bg text-status-part-text border-status-part-border" },
  paid:        { label: "Paid",        cls: "bg-status-paid-bg text-status-paid-text border-status-paid-border" },
  over_budget: { label: "Over Budget", cls: "bg-status-danger-bg text-status-danger-text border-status-danger-border" },
};

export function statusMeta(key) {
  return STATUS_META[key] || STATUS_META.not_quoted;
}
